import axios from 'axios';

// Create axios instance with base URL from environment variable
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Cookies are automatically included in requests by the browser
// No need for manual token handling when using secure cookies

export default {
  // Registration endpoints
  async getRegistrationOptions(username, brand_id) {
  const origin = window.location.origin;
  const hostname = window.location.hostname;
  const rpID = hostname.includes('localhost') ? 'localhost' : hostname;    
    return apiClient.post('/register_options', { username, brand_id, rpID, origin });
  },
  
  async verifyRegistration(username, attestationResponse, brand_id) {
  const origin = window.location.origin;
  const hostname = window.location.hostname;
  const rpID = hostname.includes('localhost') ? 'localhost' : hostname;     
    return apiClient.post('/register_verify', { 
      username, 
      attestationResponse , brand_id, rpID, origin
    });
  },
  
  // Authentication endpoints
  async getAuthenticationOptions(username, brand_id) {
  const origin = window.location.origin;
  const hostname = window.location.hostname;
  const rpID = hostname.includes('localhost') ? 'localhost' : hostname;    
    return apiClient.post('/login_options', { username, brand_id, rpID, origin });
  },
  
  async verifyAuthentication(username, assertionResponse, brand_id) {
  const origin = window.location.origin;
  const hostname = window.location.hostname;
  const rpID = hostname.includes('localhost') ? 'localhost' : hostname;    
    return apiClient.post('/login_verify', { 
      username, 
      assertionResponse , brand_id, rpID, origin
    });
  }
};